import React, { useEffect, useState } from 'react'

import './App.css'
import { useNavigate } from 'react-router-dom';
import DataTable from './DataTable';
import StanderdConstants from '../../services/StanderdConstants';
import { AddIconButton, EditIconButton } from '../../ButtonsIconsInputs/IconButtons';
import DeleteConfirmation from '../reusableComp/Deletecomfirmation';
import Heading from '../reusableComp/Heading';
import { InputBox } from '../../ButtonsIconsInputs/CustomInputs';
import CreateCandidateGroup from './CreateCandidateGroup';
import EditModal from './EditModal';
import { useToast } from '../../services/useToast';
import { useToastContext } from '../../services/ToastProvider';


function CandidateGroup() {
    const [Data, SetData] = useState([]);
    const [open, setopen] = useState(false);
    const [insertionStatus, setInsertionStatus] = useState(false);
    const [editStatus, setEditStatus] = useState(false);
    const [filteredData, setfilteredData] = useState([]);
    const [editOpen, setEditOpen] = useState(false);
    const [currentDatarow, setcurrentDatarow] = useState(null);
    const api_url = process.env.REACT_APP_API_URL
    const navigate = useNavigate()
    const {showToast} = useToastContext()
    const [query, setQuery] = useState('');
    useEffect(() => {
        if (insertionStatus) {
            getAssessmentSeries()
            setInsertionStatus(false);
        }
    }, [insertionStatus, Data]);


    const handleopen = () => { setopen(true); }
    const handleclose = () => { setopen(false); }
    const handleEditOpen = (Data, index) => {
        setcurrentDatarow(Data); setEditOpen(true);
    }
    const handleEditClose = () => { setEditOpen(false); setcurrentDatarow(null); console.log("called") }
    const handleDelete = async (item) => {
        let Id = Object.values(item)[0]
                
        const res = await fetch(`${api_url}/CandidateGroup/Delete/?Id=${Id}`, {
            method: 'DELETE',
            headers: { 'Content-Type': "application/json" },
        });
        if (res.ok) {
            showToast('Deleted Successfully','success')
            setInsertionStatus(true);
        } else {
            showToast('Something went Wrong','error')

                    }
    }
    const AssessmentActions = [
        {
            label: StanderdConstants.EDIT_LABEL,
            handler: handleEditOpen,
            tooltip: StanderdConstants.EDIT_LABEL,
            ButtonComponent: EditIconButton,
        },
        {
            label: StanderdConstants.DELETE_LABEL,
            handler: handleDelete,
            tooltip: StanderdConstants.DELETE_LABEL,
            ButtonComponent: DeleteConfirmation,

        }

    ];




    const getAssessmentSeries = async () => {
        try {
            const result = await fetch(`${process.env.REACT_APP_API_URL}/CandidateGroup/getData`, {
                method: 'get',
                headers: { 'Content-Type': 'application/json' },

            });
            const response = await result.json();
            if (result.ok) {
                SetData(response.data)
                setfilteredData(response.data)
            }

        } catch (error) {
                    }
    };

    useEffect(() => {
        getAssessmentSeries();
    }, []);



    useEffect(() => {
                if (editStatus) {
            getAssessmentSeries()
            setEditStatus(false)
        }
    }, [editStatus]);

    const columns = [
        { header: StanderdConstants.HEADER_CANDIDATEBATCH, field: StanderdConstants.COLUMN_DBTABLE_CANDIDATEBATCH },
        { header: StanderdConstants.HEADER_CBC, field: StanderdConstants.COLUMN_DBTABLE_CBC }
    ];

    const handleSearch = (e) => {
                        const searchQuery = e.target.value.toLowerCase();
        setQuery(searchQuery);
        if (!searchQuery) {
            setfilteredData(Data);
        } else {
                        const result = Data.filter(row =>
                Object.values(row) // Get all values from the object (row)
                    .some(value =>
                        value?.toString().toLowerCase().includes(searchQuery.toLowerCase()) // Check if any value contains the search query
                    )
            );
                        setfilteredData(result);
        }
    }

    return (
        <div className="container mx-auto py-8 px-2">
            <Heading heading={"Manage Candidate Groups"} />
            <div className="flex flex-row  justify-between space-x-2 my-2 ">
                <div className="flex items-center space-x-2">
                    <InputBox
                        inputId='searchOrg'
                        inputLabel="Search Group"
                        inputValueValue={query}
                        onChange={handleSearch}
                        className="border p-2 rounded-lg"
                        type="text"
                    />

                </div>
                {<div>
                    <AddIconButton action={() => handleopen(true)} id={"CanidateGroup"} tooltip='Add' />
                    {open && <CreateCandidateGroup handleclose={handleclose} setStatus={setInsertionStatus} />}

                </div>}

            </div>
            <DataTable Data={filteredData} columns={columns} actions={AssessmentActions} />




            {editOpen && (
                <EditModal
                    Data={currentDatarow}
                    handleClose={handleEditClose}
                    setStatus={setEditStatus} />
            )}
        </div>

    )

}

export default CandidateGroup